export default class SDAClient {
    constructor(data = {}) {
        this.Partner_ID = data.Partner_ID || null
        this.Branch_ID = data.Branch_ID || null
        this.Project_ID = data.Project_ID || null
        this.PartnerBrandName = data.PartnerBrandName || ''
        this.BranchAddress = data.BranchAddress || ''
        this.ProjectName = data.ProjectName || ''
        this.PosibleRejectReason = data.PosibleRejectReason || ''
        this.Store_ID = data.Store_ID || null
        this.SDAPartnerMove_ID = data.SDAPartnerMove_ID || null
    }
} 